import React, { useEffect, useState } from "react";
import { getDocSignatureInfo } from "../../api/papers";
import { fetchUserDetail } from "../../api/users/user";

export default function SignTableQuality({ data }) {
  const [signData, setSignData] = useState({
    constructor: { name: "-", company: "-", sign: null },
    pm: { name: "-", company: "-", sign: null },
  });

  useEffect(() => {
    if (!data?.header) return;

    // 문서 번호 찾기 (우선순위: dns > doc_dns > mi_dns)
    const targetDns =
      data.dns || data.doc_dns || data.mi_dns || data.header.mi_dns;

    const header = data.header;
    const assigned = header.assigned_people || [];
    const infoSnapshot = header.assigned_people_info || {};

    const constructorId = assigned[0];
    const pmId = assigned[1];

    const load = async () => {
      // 1. 기본값: 스냅샷 사용
      const result = {
        constructor: {
          name: infoSnapshot.constructor?.name || "-",
          company: infoSnapshot.constructor?.company || "-",
          sign: infoSnapshot.constructor?.sign || null,
        },
        pm: {
          name: infoSnapshot.pm?.name || "-",
          company: infoSnapshot.pm?.company || "-",
          sign: infoSnapshot.pm?.sign || null,
        },
      };

      // 2. 시공사 (Constructor) 데이터 보완
      if (constructorId) {
        try {
          // 이름이 없으면 API 조회
          if (result.constructor.name === "-") {
            const u = await fetchUserDetail(constructorId);
            result.constructor.name =
              u.data.name || `${u.data.last_name}${u.data.first_name}`;
            result.constructor.company = u.data.company || "-";
          }
          // 서명이 없으면 API 조회
          if (!result.constructor.sign && targetDns) {
            const s = await getDocSignatureInfo(
              targetDns,
              data.project,
              constructorId
            );
            if (s.data?.sign) result.constructor.sign = s.data.sign;
          }
        } catch {}
      }

      // 3. PM (Manager) 데이터 보완
      if (pmId) {
        try {
          if (result.pm.name === "-") {
            const u = await fetchUserDetail(pmId);
            result.pm.name =
              u.data.name || `${u.data.last_name}${u.data.first_name}`;
            result.pm.company = u.data.company || "-";
          }
          // PM 서명 조회
          if (targetDns) {
            const s = await getDocSignatureInfo(targetDns, data.project, pmId);
            if (s.data?.sign) result.pm.sign = s.data.sign;
          }
        } catch {}
      }

      setSignData(result);
    };

    load();
  }, [data]);

  const { constructor, pm } = signData;
  const header = data?.header || {};

  // 🔥 핵심: PM 서명은 '이미지'도 있고 '점검일자(check_date)'도 있어야 보임
  const showPmSign = pm.sign && header.check_date;

  return (
    <div className="mt-8">
      <div className="text-body-bold mb-2">결재 승인</div>
      <table className="doc-table w-full text-center text-xs table-fixed">
        <thead className="doc-thead">
          <tr>
            <th className="doc-th w-[15%]">구분</th>
            <th className="doc-th w-[25%]">소속</th>
            <th className="doc-th w-[20%]">성명</th>
            <th className="doc-th w-[20%]">일자</th>
            <th className="doc-th w-[20%]">서명</th>
          </tr>
        </thead>
        <tbody>
      {/* 시공사 행: 모두 항상 보임 */}
          <tr>
            <td className="doc-td">시공자</td>
            <td className="doc-td">{constructor.company}</td>
            <td className="doc-td">{constructor.name}</td>
            <td className="doc-td">
              {header.write_date}
            </td>
            <td className="doc-td h-[60px] align-middle relative">
              {constructor.sign ? (
                <img
                  src={constructor.sign}
                  alt="sign"
                  className="h-[40px] mx-auto object-contain absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                />
              ) : (
                <span className="text-gray-300">-</span>
              )}
            </td>
          </tr>

          {/* PM 행: 승인(is_signed) 시에만 모든 정보 노출 */}
          <tr>
            <td className="doc-td">담당PM</td>
            <td className="doc-td">
              {header.is_signed || header.approval_date ? pm.company : "-"}
            </td>
            <td className="doc-td">
              {header.is_signed || header.approval_date ? pm.name : "-"}
            </td>
            <td className="doc-td">
              {header.is_signed || header.approval_date
                ? header.approval_date || header.check_date
                : ""}
            </td>
            <td className="doc-td h-[60px] align-middle relative">
              {pm.sign && (header.is_signed || header.approval_date) ? (
                <img
                  src={pm.sign}
                  alt="sign"
                  className="h-[40px] mx-auto object-contain absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                />
              ) : (
                <span className="text-gray-300">미결재</span>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
